<template>
  <div class="container">
    <p>{{ t('determineIllumination') }}</p>
    <EquationBlock
      :equations="equations"
    />
    <hr />
    <div class="row">
      <div class="col-sm">
        <GenericInput
          :input-label="t('desiredLumens')"
          v-model.number="lumensNeededSqFt"
          :conversion-factors="conversionFactors.basicArea"
          per
          invert
        />
        <GenericInput
          :input-label="t('desiredWatts')"
          v-model.number="wattageNeededSqFt"
          :conversion-factors="conversionFactors.basicArea"
          per
          invert
        />
        <GenericInput
          :input-label="t('growAreaWidth')"
          v-model.number="growSpaceWidthFt"
          :conversion-factors="conversionFactors.basicDistance"
        />
        <GenericInput
          :input-label="t('growAreaLength')"
          v-model.number="growSpaceLengthFt"
          :conversion-factors="conversionFactors.basicDistance"
        />
      </div>
      <div class="col-sm">
        <FixedUnitOutput
          :output-label="t('illuminationNeeded')"
          :number="lumensNeeded"
          :unit="t('lumens')"
        />
        <FixedUnitOutput
          :output-label="t('wattsNeeded')"
          :number="wattsNeeded"
          :unit="t('watts')"
        />
      </div>
      <i>
        {{ t('lumensWattsNote') }}
      </i>
    </div>
  </div>
</template>
  <script>
  import GenericInput from '../inputs/GenericInput.vue';
  import FixedUnitOutput from '../inputs/FixedUnitOutput.vue';
  import EquationBlock from '../inputs/EquationBlock.vue';
  import ConversionFactors from '../../utils/conversion_factors';

  import { ref, computed, reactive } from 'vue';
  import { useI18n } from 'vue-i18n';
  
  export default {
    components: {
      GenericInput,
      FixedUnitOutput,
      EquationBlock,
    },
    setup(){
        const lumensNeededSqFt = ref(8000);
        const wattageNeededSqFt = ref(45);
        const growSpaceWidthFt = ref(10);
        const growSpaceLengthFt = ref(8);
        const conversionFactors = ref(ConversionFactors);

        const { t, tm } = useI18n();

        // Create a reactive object with a function
        const translations = reactive({
          t: (key) => t(key)
        })

        const equations = computed(() => {
            return tm('lightingEquations');
        })

        const lumensNeeded = computed(() => {
            return Math.round(area.value * lumensNeededSqFt.value);
        });

        const wattsNeeded = computed(() => {
            return Math.round(area.value * wattageNeededSqFt.value);
        });

        const area = computed(() => {
            return growSpaceWidthFt.value * growSpaceLengthFt.value;
        });

        return { equations, lumensNeededSqFt, wattageNeededSqFt, growSpaceWidthFt, growSpaceLengthFt, conversionFactors, lumensNeeded, wattsNeeded, area, t: translations.t };

    }
  };
  </script>
  